import * as stylex from '@stylexjs/stylex';
import type { StyleXStyles } from '@stylexjs/stylex';
import { stylexProps } from '@/util/stylexProps';
import { ReactNode, type JSX } from 'react';
type Props = {
  children: ReactNode;
  tag?: 'h1' | 'h2' | 'h3' | 'div';
  style?: StyleXStyles;
  className?: string;
  letterSpacing?: 'base' | 'small' | 'wide';
  size?: 'header' | 'secondaryHeader' | 'baseDesktop' | 'base' | 'small' | 'xxs';
};
export function PFText(props: Props): JSX.Element {
  const {
    tag = 'div',
    letterSpacing = 'base',
    style,
    className,
    size,
    children
  } = props;
  const Tag = tag;
  return <Tag {...stylexProps(className, letterSpacing === 'base' && styles.trackingBase, letterSpacing === 'wide' && styles.trackingWide, letterSpacing === 'small' && styles.trackingSmall, size === 'xxs' && styles.sizeXxs, size === 'small' && styles.sizeSmall, size === 'base' && styles.sizeBase, size === 'baseDesktop' && styles.sizeBaseDesktop, size === 'secondaryHeader' && styles.sizeSecondaryHeader, size === 'header' && styles.sizeHeader, style)}>
      {children}
    </Tag>;
}
const styles = {
  trackingBase: {
    kb6lSQ: "x13qdn04",
    $$css: true
  },
  trackingWide: {
    kb6lSQ: "xribhvm",
    $$css: true
  },
  trackingSmall: {
    kb6lSQ: "x1dor1uw",
    $$css: true
  },
  sizeXxs: {
    kGuDYH: "xfifm61",
    kLWn49: "x1d3mw78",
    $$css: true
  },
  sizeSmall: {
    kGuDYH: "xif65rj x1uzwvoj",
    kLWn49: "x1d3mw78 x1hilpnq",
    $$css: true
  },
  sizeBase: {
    kGuDYH: "x1j61zf2 xw0u54u",
    kLWn49: "xggjnk3 x16qfn61",
    $$css: true
  },
  sizeBaseDesktop: {
    kGuDYH: "x1q7jzdg",
    kLWn49: "x1o2sk6j",
    $$css: true
  },
  sizeSecondaryHeader: {
    kGuDYH: "x1q7jzdg xyamk6z",
    kLWn49: "x1o2sk6j x3ikqco",
    $$css: true
  },
  sizeHeader: {
    kGuDYH: "x1pvqxga x14linz1",
    kLWn49: "xcgk4ki x1v5n6ek",
    $$css: true
  }
};